import { action, computed, makeObservable, observable } from 'mobx';

export class PublisherManager {
    @observable publisherId = null;
    @observable publisherName = null;
    @observable hasDocReaderId = false;
    @observable hasWebReaderId = false;
    @observable hasWebSpellCheckerId = false;
    @observable hasOxfordDictionaryId = false;
    @observable hasTextHelpId = false;
    @observable docReaderId = null;
    @observable webReaderId = null;
    @observable textHelpId = null;
    @observable webSpellCheckerId = null;
    @observable rsHref = null;
    /** null = unset (API didn't include the flag) → treat as enabled */
    @observable publisherAiEnabled = null;

    constructor() {
      makeObservable(this);
    }

    @action
    setRsRef= (url) => {
      this.rsHref = url;
    }

    /**
     * Publisher-level AI toggle. When false, AI features are off regardless of user permissions.
     * Defaults to true when the API response doesn't include the flag (safe for older responses).
     */
    @computed get isPublisherAiEnabled() {
      if (this.publisherAiEnabled === null || this.publisherAiEnabled === undefined) {
        return true;
      }
      return this.publisherAiEnabled === true || this.publisherAiEnabled === 'true';
    }

    @action setPublisherAiEnabled(val) {
      this.publisherAiEnabled = val ?? null;
    }

    @action setPublisherOptionsFromResponse(response) {
      this.setDocReaderId(response.docReaderId);
      this.setHasDocReaderId(response.hasDocReaderId);
      this.setHasTextHelpId(response.hasTextHelpId);
      this.setHasWebReaderId(response.hasWebReaderId);
      this.setHasWebSpellCheckerId(response.hasWebSpellCheckerId);
      this.setHasOxfordDictionaryId(response.hasOxfordDictionaryId);
      this.setPublisherId(response.publisherId);
      this.setPublisherName(response.publisherName);
      this.setTextHelpId(response.textHelpReactId);
      this.setWebReaderId(response.webReaderId);
      this.setWebSpellCheckerId(response.webSpellCheckerId);
      if (response.aiEnabled !== undefined) {
        this.setPublisherAiEnabled(response.aiEnabled);
      }
    }

    @action setPublisherId(val) {
      this.publisherId = val;
    }

    @action setPublisherName(val) {
      this.publisherName = val;
    }

    @action setHasDocReaderId(val) {
      this.hasDocReaderId = val;
    }

    @action setHasWebReaderId(val) {
      this.hasWebReaderId = val;
    }

    @action setHasWebSpellCheckerId(val) {
      this.hasWebSpellCheckerId = val;
    }

    @action setHasOxfordDictionaryId(val) {
      this.hasOxfordDictionaryId = val;
    }

    @action setHasTextHelpId(val) {
      this.hasTextHelpId = val;
    }

    @action setDocReaderId(val) {
      this.docReaderId = val;
    }

    @action setWebReaderId(val) {
      this.webReaderId = val;
    }

    @action setTextHelpId(val) {
      this.textHelpId = val;
    }

    @action setWebSpellCheckerId(val) {
      this.webSpellCheckerId = val;
    }
}
export default new PublisherManager();
